// extracted by mini-css-extract-plugin
export default {"container":"AiChatAssistantNew_container__SZwcy","noPadding":"AiChatAssistantNew_noPadding__nWll2"};